import { render, staticRenderFns } from "./Referrers.vue?vue&type=template&id=e4c27be0&"
import script from "./Referrers.vue?vue&type=script&lang=js&"
export * from "./Referrers.vue?vue&type=script&lang=js&"
import style0 from "./Referrers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Referrers.vue"
export default component.exports